import { generateOpacityUtils } from '../generators';

export const opacity = generateOpacityUtils();
